const dynamicScriptsMap = {
    "@sentry/browser": () => import("@sentry/browser"),
    "@zootools/email-spell-checker": () => import("@zootools/email-spell-checker"),
    "@yaireo/tagify": () => import("@yaireo/tagify"),
    "intl-tel-input": () => import("intl-tel-input"),
    "@adyen/adyen-web": () => import("@adyen/adyen-web"),
    "InteractionScriptsLoader.js": () => import("./libs/InteractionScriptsLoader.js"),
    "snake.lib.analytics.js": () => import("./libs/snake.lib.analytics.js"),
    "snake.lib.api.js": () => import("./libs/snake.lib.api.js"),
    "snake.lib.event.js": () => import("./libs/snake.lib.event.js"),
    "snake.lib.hook.js": () => import("./libs/snake.lib.hook.js"),
    "snake.lib.identity.js": () => import("./libs/snake.lib.identity.js"),
    "snake.lib.profile.js": () => import("./libs/snake.lib.profile.js"),
    "snake.lib.promo.js": () => import("./libs/snake.lib.promo.js"),
    "snake.lib.router.js": () => import("./libs/snake.lib.router.js"),
    "snake.lib.storage.js": () => import("./libs/snake.lib.storage.js"),
    "snake.lib.summary.js": () => import("./libs/snake.lib.summary.js"),
    "snake.lib.trace.js": () => import("./libs/snake.lib.trace.js"),
    "snake.lib.url.js": () => import("./libs/snake.lib.url.js"),
    "snake.lib.utils.js": () => import("./libs/snake.lib.utils.js"),
    "snake.lib.validate.js": () => import("./libs/snake.lib.validate.js"),
    "checkout.js": () => import("./checkout.js"),
    "component.addresses.js": () => import("./component.addresses.js"),
    "component.agent.js": () => import("./component.agent.js"),
    "component.commerceBanner.js": () => import("./component.commerceBanner.js"),
    "component.js": () => import("./component.js"),
    "component.load.js": () => import("./component.load.js"),
    "component.payment.js": () => import("./component.payment.js"),
    "component.paymentExpress.js": () => import("./component.paymentExpress.js"),
    "component.premiumBanner.js": () => import("./component.premiumBanner.js"),
    "component.profile.js": () => import("./component.profile.js"),
    "config.js": () => import("./config.js"),
};

window.loadScript = async (scriptName) => {
    if (typeof scriptName !== "string") throw new TypeError("script name must be a string");

    const cache = (window.snakeCheckout ??= {});
    cache.loadedPromises ??= {};
    cache.loadedModules ??= {};

    if (cache.loadedModules[scriptName]) return cache.loadedModules[scriptName];
    if (cache.loadedPromises[scriptName]) return cache.loadedPromises[scriptName];

    const scriptLoader = dynamicScriptsMap[scriptName] || (() => import(/* @vite-ignore */ scriptName));

    const scriptLoadPromise = await scriptLoader()
        .then((mod) => {
            const resolved = mod.default ?? mod;
            cache.loadedModules[scriptName] = resolved;
            delete cache.loadedPromises[scriptName];
            return resolved;
        })
        .catch((error) => {
            delete cache.loadedPromises[scriptName];
            delete cache.loadedModules[scriptName];
            console.error("Script failed to load:", error);
            throw error;
        });

    cache.loadedPromises[scriptName] = scriptLoadPromise;

    return scriptLoadPromise;
};
